import { combineReducers, configureStore } from '@reduxjs/toolkit';

import { authReducer } from './auth/authSlice';
import { invoiceReducer } from './invoice/invoiceSlice';
import { employerReducer } from './employer/employerSlice';
import { employmentReducer } from './employment/employmentSlice';
import { payrollReducer } from './payroll/payrollSlice';
import { fileReducer } from './file/fileSlice';
import { foraGlobalReducer } from './fora-global/foraGlobalSlice';
import { contentReducer } from './content/contentSlice';
import { errorReducer } from './error/errorSlice';
import { handleThunkErrors } from './error/middlewares/handleThunkErrors';
import { reportHistoryReducer } from './reportHistory/reportHistorySlice';
import { payHistoryReducer } from './payHistory/payHistorySlice';
import { fileDashboardReducer } from './fileDashboard/fileDashboardSlice';

const rootReducer = combineReducers({
  auth: authReducer,
  content: contentReducer,
  invoice: invoiceReducer,
  employer: employerReducer,
  employment: employmentReducer,
  error: errorReducer,
  foraGlobal: foraGlobalReducer,
  payroll: payrollReducer,
  file: fileReducer,
  reportHistory: reportHistoryReducer,
  payHistory: payHistoryReducer,
  fileDashboard: fileDashboardReducer,
});

export const setupStore = (preloadedState?: Partial<RootState>) => {
  return configureStore({
    reducer: rootReducer,
    preloadedState,
    middleware: getDefaultMiddleware => getDefaultMiddleware().concat(handleThunkErrors),
  });
};

export const store = setupStore();

// Infer the `RootState`, `AppStore` and `AppDispatch` types from the store itself
export type RootState = ReturnType<typeof rootReducer>;
export type AppStore = ReturnType<typeof setupStore>;
export type AppDispatch = AppStore['dispatch'];
